export default (subItemsById, item) => {
  return item.sub_items.reduce((quantity, subItemId) => {
    const subItem = subItemsById[subItemId];
    return quantity + subItem.quantity;
  }, 0);
};
